import { useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Bell, Check } from "lucide-react";

export function AlertsBell({ alerts, reload }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  const ack = async (a) => {
    await api.post("/alerts/ack", { projet: a.projet, title: a.title });
    reload();
  };

  return (
    <div className="relative">
      <button data-testid="alerts-bell" onClick={() => setOpen((v) => !v)} className="relative p-2 rounded-md hover:bg-slate-100 transition-colors">
        <Bell className="w-5 h-5 text-slate-600" />
        {alerts && alerts.count > 0 && (
          <span data-testid="alerts-count" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center">{alerts.count}</span>
        )}
      </button>
      {open && (
        <div data-testid="alerts-panel" className="absolute right-0 mt-2 w-80 bg-white border border-slate-200 rounded-xl shadow-lg z-30 overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-200 font-head font-semibold text-slate-900 text-sm flex items-center justify-between">
            {t("alerts_title")}
            {alerts && <span className="text-xs font-mono text-slate-500">{alerts.total}</span>}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {alerts && alerts.alerts.length > 0 ? alerts.alerts.map((a, i) => (
              <div key={`${a.projet}-${a.title}-${i}`} data-testid={`alert-item-${a.level}`} className="px-4 py-3 border-b border-slate-100 flex gap-2.5">
                <span className={`mt-1 w-2 h-2 rounded-full shrink-0 ${a.level === "danger" ? "bg-red-500" : "bg-amber-500"}`} />
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-semibold text-slate-900">{a.title} <span className="text-[10px] font-mono text-slate-400">· {a.projet}</span></div>
                  <div className="text-xs text-slate-600 mt-0.5">{a.text}</div>
                </div>
                <button data-testid="alert-ack" title={t("ab_mark_done")} onClick={() => ack(a)}
                  className="shrink-0 text-slate-400 hover:text-emerald-600 transition-colors"><Check className="w-4 h-4" /></button>
              </div>
            )) : <div className="px-4 py-6 text-center text-sm text-slate-500">{t("alerts_none")}</div>}
          </div>
        </div>
      )}
    </div>
  );
}
